"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideDown = slideDown;
exports.slideUp = slideUp;

/**
 * Checks whether the element has a CSS transition that can run.
 *
 * @param el The element to check.
 * @returns {boolean} Whether a transition was found.
 */
function hasTransition(el) {
  return getComputedStyle(el)['transitionDuration'] !== '0s';
}
/**
 * Slides down an element.
 *
 * @param el
 * @param callback
 */


function slideDown(el, callback) {
  // Get the natural height of the element.
  var getHeight = function getHeight() {
    var height; // Make element visible, get height and hide it again.

    el.style.display = 'block';
    height = el.scrollHeight + 'px';
    el.style.display = '';
    return height;
  };
  /**
   * Once the transition is complete, remove the inline max-height so the
   * content can scale responsively.
   *
   * @param evt
   */


  var onTransitionEnd = function onTransitionEnd(evt) {
    el.removeEventListener(evt.type, onTransitionEnd);
    el.style.height = '';

    if (callback) {
      callback();
    }
  }; // Set height to start from.


  el.style.height = '0px';
  el.addEventListener('transitionend', onTransitionEnd);
  el.style.height = getHeight(); // Fallback when no transition ran.

  if (!hasTransition(el) && callback) {
    callback();
  }
}
/**
 * Slides up an element.
 *
 * @param el
 * @param callback
 */


function slideUp(el, callback) {
  var onTransitionEnd = function onTransitionEnd(evt) {
    el.removeEventListener(evt.type, onTransitionEnd);
    el.style.height = '';

    if (callback) {
      callback();
    }
  }; // Give the element a height to change from.


  el.style.height = el.scrollHeight + 'px'; // Add event listener after an initial height is set.

  el.addEventListener('transitionend', onTransitionEnd);
  window.setTimeout(function () {
    el.style.height = '0';
  }, 1); // Fallback when no transition ran.

  if (!hasTransition(el) && callback) {
    callback();
  }
}